"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const react_1 = tslib_1.__importDefault(require("react"));
const react_hooks_1 = require("@apollo/react-hooks");
const react_hanger_1 = require("react-hanger");
const reactstrap_1 = require("reactstrap");
const index_1 = require("./index");
const QueryListItem_1 = require("./QueryListItem");
const react_2 = require("@osmosys/react");
const react_loops_1 = require("react-loops");
const react_if_1 = require("react-if");
exports.QueryList = props => {
    const { state, setState } = react_hanger_1.useSetState({
        formIsOpen: false,
        page: 0,
    });
    const { itemName, item, showNewBtn, toolbarLeft } = props;
    const itemNamePlural = `${itemName}s`;
    const ChildItem = item;
    const newQueryProps = props.queryProps;
    const newQueryVariables = Object.assign(Object.assign(Object.assign({}, props.queryVariables), newQueryProps.variables), { skip: state.page * props.pageSize, take: props.pageSize });
    delete newQueryProps.variables;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const _a = props.queryProps, { query } = _a, qProps = tslib_1.__rest(_a, ["query"]);
    const { loading, data, error, refetch } = react_hooks_1.useQuery(props.queryProps.query, Object.assign(Object.assign({}, qProps), { variables: Object.assign({}, newQueryVariables) }));
    const count = data ? data[props.countKey] : undefined;
    const newBtn = (react_1.default.createElement(react_2.OsmosysButton, { osysName: "newBtn", size: "sm", color: "success", onClick: () => {
            if (props.onClickNewBtn) {
                props.onClickNewBtn();
            }
            else {
                setState({ formIsOpen: true });
            }
        } },
        "New ",
        itemName));
    const pages = count && Math.ceil(count / props.pageSize);
    const pagination = count && pages > 1 ? (react_1.default.createElement(react_2.OsmosysPagination, { pageCount: pages, onPageChange: page => setState({
            page,
        }), forcePage: state.page })) : null;
    const hasNoItems = data && data[props.itemsKey] && data[props.itemsKey].length === 0;
    return (react_1.default.createElement(react_2.OsmosysDiv, { flexColCenteredFilled: true },
        react_1.default.createElement(react_2.OsmosysModal, { osysName: "QueryList", centered: true, placement: "auto", isOpen: state.formIsOpen, toggle: () => setState({ formIsOpen: false }) },
            react_1.default.createElement(reactstrap_1.ModalHeader, { toggle: () => setState({ formIsOpen: false }) },
                "New ",
                props.itemName),
            react_1.default.createElement(reactstrap_1.ModalBody, { className: "w-100" }, props.form instanceof react_1.default.Component
                ? props.form
                : props.form &&
                    props.form(() => refetch(), () => {
                        setState({ formIsOpen: false });
                    }, {
                        query: props.queryProps.query,
                        variables: newQueryVariables,
                    }))),
        react_1.default.createElement(react_2.OsmosysDiv, { flexRow: true, className: "mb-2" },
            react_1.default.createElement(react_if_1.When, { condition: !!toolbarLeft },
                react_1.default.createElement(react_2.OsmosysDiv, { flexFill: true }, toolbarLeft)),
            react_1.default.createElement(react_if_1.When, { condition: !hasNoItems && showNewBtn },
                react_1.default.createElement(react_2.OsmosysDiv, { flexFill: true, className: "text-right" },
                    react_1.default.createElement(react_2.OsmosysDiv, null, newBtn)))),
        react_1.default.createElement(react_if_1.When, { condition: !!loading },
            react_1.default.createElement(index_1.Loading, null)),
        react_1.default.createElement(react_if_1.When, { condition: !!error },
            react_1.default.createElement(react_2.OsmosysErrorAlert, { apolloError: error, retry: () => refetch(newQueryVariables) })),
        react_1.default.createElement(react_2.OsmosysDiv, { flexColCenteredFilled: true },
            react_1.default.createElement(react_2.OsmosysDiv, null,
                react_1.default.createElement(react_loops_1.For, { of: data ? data[props.itemsKey] : [], ifEmpty: react_1.default.createElement(react_2.OsmosysDiv, { flexColCenteredFilled: true, className: "text-center" },
                        react_1.default.createElement(react_2.OsmosysDiv, null,
                            react_1.default.createElement("p", { className: classnames_1.default('lead', {
                                    'mb-0': !(showNewBtn && newBtn),
                                }) },
                                "No ",
                                itemNamePlural,
                                " found"),
                            showNewBtn && newBtn)) }, (itemData, { index }) => {
                    return props.useContainer !== false ? (react_1.default.createElement(QueryListItem_1.QueryListItem, { key: index, itemPadding: props.itemPadding, itemContainer: props.itemContainer, onClick: () => props.onItemClick && props.onItemClick(itemData), url: props.itemURL ? props.itemURL(itemData) : undefined },
                        react_1.default.createElement(ChildItem, Object.assign({ data: itemData, _refetch: refetch }, (props.itemProps ? props.itemProps(itemData) : {}))))) : (react_1.default.createElement(ChildItem, { _refetch: refetch, key: itemData.id || index, data: itemData }));
                }))),
        pagination,
        react_1.default.createElement(react_if_1.When, { condition: count && count > 0 },
            react_1.default.createElement(react_2.OsmosysDiv, null,
                react_1.default.createElement("p", { className: "text-muted" },
                    count,
                    " ",
                    count === 1 ? itemName : itemNamePlural)))));
};
exports.QueryList.defaultProps = {
    pageSize: 10,
};
//# sourceMappingURL=QueryList.js.map